<template>
  <div  class="ShowingStandContainer" >
    <div class="ShowingStand" v-for="(item, index) in array" :key=index>
       <div class="tag">{{item.title}} </div><img class="mainPic" :src="item.src" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ShowingStand',
  props: {
    array:{
          type: Array, default() {
          return []
        }
      },

  },
  data () {
    return {
      img1:require("@/assets/homepage/pic_zbyy.png")
    }
  },

  methods: {

  }
}
</script>
<style lang="scss" scoped>
.ShowingStandContainer{
  margin-top: 72px;
  display: flex;
  flex-wrap: nowrap;
  width:1375px;
  .ShowingStand{
  margin-right: 60px;
  box-sizing: border-box;
  .tag{
    width: 600px;
    height: 32px;
    font-size: 32px;
    font-family: "SourceHanSansSC-Heavy-2";
    font-weight: 800;
    color: #2A45A7;
    text-align: left;
  }

  .mainPic{
    width: 658px;
    height: 414px;
    margin-top: 31px;
  }

}

}


</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/ShowingStand.vue